
import React from 'react';
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import ShareToggle from './ShareToggle';
import ShareLink from './ShareLink';

interface ShareDialogContentProps {
  isPublic: boolean;
  setIsPublic: (value: boolean) => void;
  shareableLink: string;
  onGenerateLink: () => Promise<void>;
  isGeneratingLink: boolean;
  hasPublicShare: boolean;
  hasPrivateShare: boolean;
  existingPublicLink?: string;
  existingPrivateLink?: string;
}

const ShareDialogContent: React.FC<ShareDialogContentProps> = ({
  isPublic,
  setIsPublic,
  shareableLink,
  onGenerateLink,
  isGeneratingLink,
  hasPublicShare,
  hasPrivateShare,
  existingPublicLink,
  existingPrivateLink
}) => {
  const isShareDisabled = (isPublic && hasPublicShare) || (!isPublic && hasPrivateShare);

  return (
    <>
      <DialogHeader>
        <DialogTitle>Share Note</DialogTitle>
        <DialogDescription>
          Choose how you want to share this note
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <ShareToggle 
          isPublic={isPublic} 
          setIsPublic={setIsPublic}
          hasPublicShare={hasPublicShare}
          hasPrivateShare={hasPrivateShare}
        />
        
        {/* Show existing public link */}
        {hasPublicShare && existingPublicLink && (
          <div className="space-y-2">
            <p className="text-sm text-gray-500">Existing public link:</p>
            <ShareLink shareableLink={existingPublicLink} />
          </div>
        )}

        {/* Show existing private link */}
        {hasPrivateShare && existingPrivateLink && (
          <div className="space-y-2">
            <p className="text-sm text-gray-500">Existing private link:</p>
            <ShareLink shareableLink={existingPrivateLink} />
          </div>
        )}

        {/* Show generate link button only if the current mode doesn't have a link yet */}
        {!isShareDisabled && (
          shareableLink ? (
            <ShareLink shareableLink={shareableLink} />
          ) : (
            <Button 
              onClick={onGenerateLink} 
              className="w-full"
              disabled={isGeneratingLink}
            >
              {isGeneratingLink ? 'Generating...' : 'Generate Share Link'}
            </Button>
          )
        )}
      </div>
    </>
  );
};

export default ShareDialogContent;
